export default "__VITE_ASSET__7uvF3Gz0__"